import { createSelector } from 'reselect';

import { WhitelistType } from 'constants/whitelist';

import { getCompany } from './company.selectors';

const selectCompanyWhitelist = createSelector(getCompany, ({ whitelist }) => whitelist);

export const selectCompanyWhitelistEmails = createSelector(selectCompanyWhitelist, items =>
  items.filter(item => item.type === WhitelistType.EMAIL),
);

export const selectCompanyWhitelistPhones = createSelector(selectCompanyWhitelist, items =>
  items.filter(item => item.type === WhitelistType.PHONE),
);
